import { snakeCase } from 'lodash';
import { RobotManufacturerContextValue } from '../pages/machine/robot-manufacturer-context';
import { ManufacturerNameArg, RobotManufacturer } from './robot.types';

const RobotManufacturerSet: Set<string> = new Set(
  Object.values(RobotManufacturer)
);

export const isRobotManufacturer = (
  value?: string | null
): value is RobotManufacturer => {
  if (!value) {
    return false;
  }
  return RobotManufacturerSet.has(value);
};

export const getManufacturerByName = (
  manufacturerName: ManufacturerNameArg
): RobotManufacturer | undefined => {
  const snakeCased = snakeCase(manufacturerName ?? '');

  if (isRobotManufacturer(snakeCased)) {
    return snakeCased;
  }
};

/**
 * Determines if a robot uses BeaconEngine based on manufacturer context.
 *
 * Currently only FANUC uses BeaconEngine, but this function is designed to be
 * extensible as other manufacturers may adopt BeaconEngine in the future.
 *
 * @param context - The robot manufacturer context
 * @returns true if the robot uses BeaconEngine
 */
export const hasBeaconEngineSupport = (
  context: RobotManufacturerContextValue
): boolean => {
  return context.manufacturer === RobotManufacturer.FANUC;
};
